// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as ReactNative from "react-native";
import * as Blocks__Utils from "./utils/Blocks__Utils.bs.js";
import * as Utils__JsonPlus from "@pageblocks/utils/src/jsonPlus/Utils__JsonPlus.bs.js";
import * as Renderer__Context from "@pageblocks/renderer/src/Renderer__Context.bs.js";
import * as Renderer__Version from "@pageblocks/renderer/src/Renderer__Version.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Renderer__Settings from "@pageblocks/renderer/src/Renderer__Settings.bs.js";
import * as Utils__SimpleReact from "@pageblocks/utils/src/simpleReact/Utils__SimpleReact.bs.js";
import * as Utils__AllOptionalParser from "@pageblocks/utils/src/Utils__AllOptionalParser.bs.js";
import * as Blocks__SettingsRnAdapter from "./utils/Blocks__SettingsRnAdapter.bs.js";

var blockCode = "select";

function decode(dict) {
  var value = Core__Option.flatMap(dict["value"], Core__JSON.Decode.string);
  var display = Core__Option.flatMap(dict["display"], Core__JSON.Decode.string);
  if (value !== undefined && display !== undefined) {
    return {
            value: value,
            display: display
          };
  }
  
}

function makeStyleFromSettings(settings, context) {
  return [
          Blocks__SettingsRnAdapter.Style.background(settings, context),
          Blocks__SettingsRnAdapter.Style.padding(settings, context),
          Blocks__SettingsRnAdapter.Style.margin(settings, context),
          Blocks__SettingsRnAdapter.Style.border(settings, context)
        ];
}

function makeItemStyleFromSettings(settings, context) {
  return [Blocks__SettingsRnAdapter.Style.border(settings, context)];
}

function Blocks__Select$Component(props) {
  var handleAction = props.handleAction;
  var testID = props.testID;
  var __context = props.context;
  var context = __context !== undefined ? Caml_option.valFromOption(__context) : Renderer__Context.makeEmpty();
  var settings = Renderer__Settings.deserialize(props.settings);
  var getString = function (code) {
    return Renderer__Settings.getString(settings, code, context);
  };
  var getList = function (code) {
    return Renderer__Settings.getList(settings, code, context);
  };
  var onSelectActions = Core__Option.getOr(Core__Option.flatMap(Utils__AllOptionalParser.get(Utils__AllOptionalParser.obj(props.triggerActions), "onSelect"), Blocks__Utils.getActions), []);
  var items = Core__Option.map(Core__Option.map(Core__Option.map(getList("values"), (function (__x) {
                  return Core__Array.filterMap(__x, decode);
                })), (function (x) {
              return x.map(function (param) {
                          var value = param.value;
                          var tmp = {
                            borderWidth: 1,
                            alignSelf: "flex-start",
                            padding: 8
                          };
                          var tmp$1 = Core__Option.getOr(Core__Option.map(getString("selectedValue"), (function (selectedValue) {
                                      return value === selectedValue;
                                    })), false) ? "#fcef8d" : undefined;
                          if (tmp$1 !== undefined) {
                            tmp.backgroundColor = Caml_option.valFromOption(tmp$1);
                          }
                          return JsxRuntime.jsx(ReactNative.TouchableOpacity, {
                                      style: [
                                        tmp,
                                        makeStyleFromSettings(settings, context)
                                      ],
                                      onPress: onSelectActions.length !== 0 && handleAction !== undefined ? (function (param) {
                                            onSelectActions.forEach(function (action) {
                                                  var id = Core__Option.getOr(Utils__AllOptionalParser.get(Utils__AllOptionalParser.obj(action), "id"), null);
                                                  var code = Core__Option.getOr(Utils__AllOptionalParser.get(Utils__AllOptionalParser.obj(action), "code"), null);
                                                  var payload = Utils__JsonPlus.addEntries(Core__Option.getOr(Utils__AllOptionalParser.get(Utils__AllOptionalParser.obj(action), "payload"), null), [[
                                                          "value",
                                                          value
                                                        ]]);
                                                  var newAction = Object.fromEntries([
                                                        [
                                                          "id",
                                                          id
                                                        ],
                                                        [
                                                          "code",
                                                          code
                                                        ],
                                                        [
                                                          "payload",
                                                          payload
                                                        ]
                                                      ]);
                                                  handleAction(newAction);
                                                });
                                          }) : undefined,
                                      testID: testID,
                                      children: Caml_option.some(JsxRuntime.jsx(ReactNative.Text, {
                                                children: Caml_option.some(param.display)
                                              }))
                                    }, value);
                        });
            })), (function (prim) {
          return prim;
        }));
  return Utils__SimpleReact.renderIfSome(items, (function (items) {
                var settingsStyle = makeItemStyleFromSettings(settings, context);
                return JsxRuntime.jsx(ReactNative.View, {
                            style: [
                              {
                                flexDirection: "row",
                                flexWrap: "wrap",
                                gap: 4
                              },
                              settingsStyle
                            ],
                            children: Caml_option.some(items)
                          });
              }));
}

var Component = {
  make: Blocks__Select$Component
};

var descriptor_meta = {
  version: 1,
  minRendererVersion: Renderer__Version.current
};

var descriptor_declaredTriggers = [{
    code: "onSelect",
    name: "On Select"
  }];

var descriptor_declaredSettings = [{
    code: "general",
    name: "General",
    settings: [{
        code: "values",
        name: "Values",
        dataType: {
          TAG: "List",
          _0: {
            itemSchema: [
              {
                key: "value",
                dataType: {
                  TAG: "String",
                  _0: {}
                }
              },
              {
                key: "display",
                dataType: {
                  TAG: "String",
                  _0: {}
                }
              }
            ],
            defaultValues: [],
            allowEmpty: true
          }
        }
      }]
  }];

var descriptor = {
  meta: descriptor_meta,
  code: blockCode,
  component: Component,
  declaredTriggers: descriptor_declaredTriggers,
  declaredSettings: descriptor_declaredSettings
};

var version = 1;

var minRendererVersion = Renderer__Version.current;

export {
  blockCode ,
  version ,
  minRendererVersion ,
  Component ,
  descriptor ,
}
/* react-native Not a pure module */
